import React from 'react';
import { Lock, Info } from 'lucide-react';

export default function DebugLogPage() {
  return (
    <div className="p-8">
      <div className="max-w-4xl mx-auto">
        <div className="mb-6">
          <h1 className="text-2xl font-semibold text-gray-800">Debug Logs</h1>
          <p className="text-sm text-gray-500 mt-1">
            Server-side logging only
          </p>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
          <div className="flex items-start">
            <Lock className="h-6 w-6 text-blue-600 mt-0.5 mr-3 flex-shrink-0" />
            <div>
              <h3 className="text-lg font-medium text-blue-900 mb-2">
                Debug Logs Are Now Secured
              </h3>
              <p className="text-blue-800 mb-4">
                For security reasons, debug logs are no longer accessible from the client side.
                This protects sensitive debugging information from potential exposure.
              </p>

              <div className="bg-white rounded-lg p-4 border border-blue-200">
                <div className="flex items-start">
                  <Info className="h-5 w-5 text-blue-600 mt-0.5 mr-2 flex-shrink-0" />
                  <div className="text-sm text-gray-700">
                    <p className="font-medium mb-2">To access debug logs:</p>
                    <ul className="list-disc list-inside space-y-1 ml-2">
                      <li>Access the internal.debug_logs table directly via your database console</li>
                      <li>Use the service role key in server-side operations</li>
                      <li>Query via Supabase Edge Functions with proper authentication</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
